import { render, staticRenderFns } from "./CreateNewProjectAction.vue?vue&type=template&id=236175dd"
import script from "./CreateNewProjectAction.vue?vue&type=script&lang=js"
export * from "./CreateNewProjectAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports